import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import { PackageType } from '../../../types';
import store from '../../store';

type MobilePackageCardViewedInput = {
    packageType: PackageType;
    price: string;
};

const { PACKAGE } = MIXPANEL_EVENT_PROPERTIES;

export const reportMobilePackageCardViewed = ({
    packageType,
}: MobilePackageCardViewedInput) => {
    const payload = {
        ...getDataFromStores(
            store.user,
            store.userActivated,
            store.pagePath,
            store.brief,
            store.variationId,
            store.projectId,
            store.sellerId,
            store.orderType
        ),
        [PACKAGE]: packageType,
    };

    mixpanel.track('Logo Maker - Packages Page - Package Card viewed', payload);
};
